<template>
    <div class="pb-12 overflow-y-auto body-wrapper">
        <div class="mx-4 lg:mx-64 pb-16 pt-20 text-center lg:pt-32 bg-center">
            <h1
                class="font-display text-3xl xl:text-4xl 2xl:text-5xl font-bold tracking-tight text-slate-900 sm:text-5xl">
                中小非标机械厂
                <span class="relative whitespace-nowrap text-blue-600">
                    <svg aria-hidden="true" viewBox="0 0 418 42"
                        class="absolute left-0 top-2/3 h-[0.58em] w-full fill-blue-300/70" preserveAspectRatio="none">
                        <path
                            d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z">
                        </path>
                    </svg>
                    <span class="relative">ERP&MES</span>
                </span>
                <span> 一体化管理系统</span>
                <span> (支持非标定制)</span>
            </h1>
            <h3 class="mt-12 text-sm lg:text-xl tracking-wide text-slate-700">
                支持产品从<strong>下单生产</strong>到<strong>出货对账</strong>全流程<strong>一体化数字管理</strong>
            </h3>
            <div class="mt-10 flex justify-center gap-x-6">
                <div class="text-white">
                    <a class="inline-flex items-center justify-center rounded-full py-2 lg:py-3 px-4 lg:px-8 text-base lg:text-lg font-semibold tracking-wide focus:outline-none bg-blue-600 hover:bg-blue-500"
                        variant="solid" color="slate" href="/apply" target="_blank">
                        申请演示
                    </a>
                </div>
                <div class="text-blue-600 hover:text-blue-500">
                    <a class="inline-flex items-center justify-center rounded-full py-2 lg:py-3 px-4 lg:px-8 text-base lg:text-lg font-semibold tracking-wide focus:outline-none border border-blue-600"
                        variant="solid" color="slate" href="/apply" target="_blank">
                        获取方案
                    </a>
                </div>
            </div>
        </div>

        <!-- <div class="mx-4 lg:mx-64 pt-8 lg:pt-12">
            <a-tabs type="card">
                <a-tab-pane key="header-tab1" tab="管订单">
                    <h3 class="text-sm lg:text-3xl tracking-wide text-slate-700">
                        生产订单一键下达，提升工厂整体效率
                    </h3>
                </a-tab-pane>
                <a-tab-pane key="header-tab2" tab="管生产">
                    生产进度透明化，订单交期易管控
                </a-tab-pane>
                <a-tab-pane key="header-tab3" tab="管库存">
                    库存数据实时准确，呆料滞料易发现
                </a-tab-pane>
                <a-tab-pane key="header-tab4" tab="找精益生产大管家">
                    3小时极速上线，数字化快人一步
                </a-tab-pane>
            </a-tabs>
        </div> -->

        <div class="px-4 lg:px-0 py-8 text-center lg:py-16 bg-[#fafafa] border-y">
            <div class="font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold">
                小投入，高收益：为工厂创造可量化价值
            </div>
            <div class="hidden lg:flex justify-center mt-6">
                <div class="w-[500px]">
                    <img class="h-[420px] rounded-xl border border-solid border-[#9fc6ff]"
                        src="@/assets/imgs/home_products/values.png" />
                </div>
                <div class="w-[600px] ml-4">
                    <img class="h-[420px] rounded-xl border border-solid border-[#9fc6ff]"
                        src="@/assets/imgs/home_products/advantage.png" />
                </div>
                <div class="w-[400px] ml-4">
                    <img class="h-[420px] rounded-xl border border-solid border-[#9fc6ff]"
                        src="@/assets/imgs/home_products/features.png" />
                </div>
                <!-- <div class="w-[560px]">
                    <div class="h-[400px] rounded-xl ml-4 p-4 border border-solid border-[#9fc6ff] bg-[#f4faff]">
                        <div class="text-lg lg:text-xl">帮助客户实现</div>
                        <a-row class="mt-6" :gutter="16">
                            <a-col :span="8" v-for="item in profits.ups" :key="item.label">
                                <a-card>
                                    <a-statistic :title="item.label" :value="item.value" suffix="%"
                                        :value-style="{ color: '#3f8600' }">
                                        <template #prefix>
                                            <a-icon style="vertical-align: 0;" type="arrow-up" />
                                        </template>
                                        </a-statistic>
                                        </a-card>
                                        </a-col>
                                        </a-row>
                                        <a-row class="mt-6" :gutter="16">
                                            <a-col :span="8" v-for="item in profits.downs" :key="item.label">
                                                <a-card>
                                                    <a-statistic :title="item.label" :value="item.value" suffix="%"
                                                        :value-style="{ color: '#1890ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                                                        <template #prefix>
                                                                                    <a-icon style="vertical-align: 0;" type="arrow-down" />
                                                                                </template>
                                                    </a-statistic>
                                                </a-card>
                                            </a-col>
                                        </a-row>
                                        </div>
                                        </div> -->
            </div>
            <div class="flex flex-col lg:hidden px-2 xl:px-24 2xl:px-64 mt-6">
                <img class="h-[260px] rounded-xl border border-solid border-[#9fc6ff]"
                    src="@/assets/imgs/home_products/advantage.png" />
                <img class="h-[320px] mt-4 rounded-xl border border-solid border-[#9fc6ff]"
                    src="@/assets/imgs/home_products/features.png" />
                <div class="rounded-xl mt-4 p-2 border border-solid border-[#9fc6ff] bg-[#f4faff]">
                    <div class="text-base lg:text-xl">帮助客户实现</div>
                    <a-row class="px-2 mt-6">
                        <a-col :span="12">
                            <a-card class="mb-2" :bodyStyle="{ padding: '12px' }" v-for="item in profits.ups"
                                :key="item.label">
                                <a-statistic :title="item.label" :value="item.value" suffix="%"
                                    :value-style="{ color: '#3f8600' }">
                                    <template #prefix>
                                        <a-icon style="vertical-align: 0;" type="arrow-up" />
                                    </template>
                                </a-statistic>
                            </a-card>
                        </a-col>
                        <a-col :span="12">
                            <a-card class="mb-2 ml-2" :bodyStyle="{ padding: '12px' }" v-for="item in profits.downs"
                                :key="item.label">
                                <a-statistic :title="item.label" :value="item.value" suffix="%"
                                    :value-style="{ color: '#1890ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                                    <template #prefix>
                                        <a-icon style="vertical-align: 0;" type="arrow-down" />
                                    </template>
                                </a-statistic>
                            </a-card>
                        </a-col>
                    </a-row>
                </div>
            </div>
        </div>

        <div class="px-4 lg:px-0 pt-8 text-center lg:pt-12 border-b">
            <div class="text-center">
                <div class="font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold">
                    帮助每个中小型非标机械厂，实现更低成本的速度出货
                </div>
                <a-tabs class="pt-2 lg:pt-4 text-lg" default-active-key="1" size="large" :animated="false">
                    <a-tab-pane key="1">
                        <template #tab>
                            <span class="flex items-center text-sm lg:text-lg">
                                <a-icon type="project" />
                                生产透明化
                            </span>
                        </template>
                        <div class="flex flex-col lg:flex-row justify-center items-center py-8 lg:py-16">
                            <div class="flex flex-col justify-start">
                                <p class="text-lg tracking-wide sm:text-xl md:text-3xl font-semibold">生产透明化</p>
                                <p class="flex items-center text-sm tracking-wide lg:text-xl mt-3 lg:mt-6">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    生产进度管理
                                </p>
                                <p class="flex items-center text-sm tracking-wide lg:text-xl pt-2">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    生产工艺管理
                                </p>
                                <p class="flex items-center text-sm tracking-wide lg:text-xl pt-2">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    生产质量管理
                                </p>
                                <p class="flex items-center text-sm tracking-wide lg:text-xl pt-2 text-left">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    库存管理
                                </p>
                            </div>
                            <a-carousel class="ml-3 lg:ml-36 w-4/5 lg:w-[760px] rounded-xl mt-2 lg:mt-0" :dots="false"
                                arrows autoplay>
                                <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;z-index: 1">
                                    <a-icon type="left-circle" />
                                </div>
                                <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                                    <a-icon type="right-circle" />
                                </div>
                                <img class="lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/process.png" />
                                <img class="lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/tech.png" />
                                <img class="lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/quality.png" />
                                <img class="lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/total.png" />
                            </a-carousel>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="2">
                        <template #tab>
                            <span class="flex items-center text-sm lg:text-lg">
                                <a-icon type="area-chart" />
                                智能排产
                            </span>
                        </template>
                        <div class="flex flex-col lg:flex-row justify-center items-center py-8 lg:py-16">
                            <div class="flex flex-col justify-start">
                                <p class="text-lg tracking-wide sm:text-xl md:text-3xl font-semibold">智能排产</p>
                                <p class="flex items-center text-sm tracking-wide lg:text-xl mt-3 lg:mt-6">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    瓶颈资源管理
                                </p>
                                <p class="flex items-center text-sm tracking-wide lg:text-xl pt-2">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    辅助优化排产
                                </p>
                            </div>
                            <a-carousel class="ml-3 lg:ml-36 w-4/5 lg:w-[760px] rounded-xl mt-2 lg:mt-0" :dots="false"
                                arrows autoplay>
                                <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;z-index: 1">
                                    <a-icon type="left-circle" />
                                </div>
                                <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                                    <a-icon type="right-circle" />
                                </div>
                                <img class="lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/stay.png" />
                                <img class="lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/sort.png" />
                            </a-carousel>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="3">
                        <template #tab>
                            <span class="flex items-center text-sm lg:text-lg">
                                <a-icon type="cloud-server" />
                                效能洞察
                            </span>
                        </template>
                        <div class="flex flex-col lg:flex-row justify-center items-center py-8 lg:py-16">
                            <div class="flex flex-col justify-start">
                                <p class="text-lg tracking-wide sm:text-xl md:text-3xl font-semibold">效能洞察</p>
                                <p class="flex items-center tracking-wide text-sm lg:text-xl mt-3 lg:mt-6">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    有效产出分析
                                </p>
                                <p class="flex items-center text-sm tracking-wide lg:text-xl pt-2">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    库存水平分析
                                </p>
                                <p class="flex items-center text-sm tracking-wide lg:text-xl pt-2">
                                    <a-icon class="mr-2 text-base text-green-500" type="check" />
                                    营运费用分析
                                </p>
                            </div>
                            <a-carousel class="ml-3 lg:ml-36 w-4/5 lg:w-[760px] rounded-xl mt-2 lg:mt-0" :dots="false"
                                arrows autoplay>
                                <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;z-index: 1">
                                    <a-icon type="left-circle" />
                                </div>
                                <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                                    <a-icon type="right-circle" />
                                </div>
                                <img class="lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]"
                                    src="@/assets/imgs/home_products/analyze.png" />
                            </a-carousel>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>

        <div class="flex flex-col justify-center mt-10">
            <p class="text-lg text-center tracking-wide sm:text-xl md:text-2xl font-semibold">高效落地流程</p>
            <div class="flex items-center justify-start lg:justify-center space-x-8 mt-6 px-8 overflow-auto">
                <div v-for="(step, index) in steps" :key="index"
                    class="relative border border-dashed border-[#9fc6ff] p-3 rounded-md">
                    <div class="flex flex-col items-center">
                        <a-tag color="blue" class="mb-2 text-sm lg:text-base">{{ step.label }}</a-tag>
                        <div
                            class="relative w-6 h-6 lg:w-8 lg:h-8 bg-[#6cb7ff] rounded-full text-white text-sm lg:text-base font-semibold flex items-center justify-center z-10">
                            {{ index + 1 }}
                        </div>
                    </div>
                    <div v-if="index !== steps.length - 1"
                        class="absolute left-[100%] top-1/2 border-t-2 border-[#9fc6ff] w-8">
                    </div>
                </div>
            </div>
        </div>
        <home-page-to-contact />
        <home-page-contact />
    </div>
</template>

<script>
import HomePageContact from './components/contact';
import HomePageToContact from './components/to-contact'

export default {
    name: 'homePageIndex',
    components: {
        HomePageContact,
        HomePageToContact
    },
    data() {
        return {
            steps: [
                { label: '价值流梳理' },
                { label: '方案选择' },
                { label: '实施配置' },
                { label: '测试上线' },
                { label: '培训与试运行' },
                { label: '辅导维护' },
                { label: '客户持续成功' },
            ],
            profits: {
                ups: [
                    { label: '有效产出提升', value: 20 },
                    { label: '生产透明度提升', value: 100 },
                    { label: '订单准交率提升', value: 20 },
                ],
                downs: [
                    { label: '车间库存降低', value: 50 },
                    { label: '生产周期缩短', value: 50 },
                    { label: '营运费用降低', value: 30 },
                ]
            }
        }
    }
}
</script>
<style scoped>
.body-wrapper {
    height: 100%;
}

.title-desc {
    background-color: #eef4ff;
}

.ant-statistic>>>.ant-statistic-title {
    color: black;
    font-weight: 500;
    font-size: 15px;
}

.ant-statistic>>>.ant-statistic-content {
    color: black;
    font-weight: 500;
    font-size: 18px;
}

.ant-tabs>>>.ant-tabs-content {
    background-color: #fafafa;
}

.ant-carousel>>>.custom-slick-arrow {
    width: 30px;
    height: 30px;
    font-size: 30px;
    color: #0086ff;
    background-color: transparent;
    opacity: 0.6;
}

.ant-carousel>>>.slick-prev {
    margin: -52px 0 0 -52px;
}

.ant-carousel>>>.slick-next {
    margin: -52px -52px 0 0;
}

.ant-carousel>>>.custom-slick-arrow:before {
    display: none;
}

.ant-carousel>>>.custom-slick-arrow:hover {
    opacity: 0.8;
}

@media only screen and (max-width: 1280px) {
    .ant-statistic>>>.ant-statistic-title {
        font-size: 14px;
    }

    .ant-statistic>>>.ant-statistic-content {
        font-size: 18px;
    }
}

@media only screen and (max-width: 480px) {
    .ant-carousel>>>.custom-slick-arrow {
        width: 20px;
        height: 20px;
        font-size: 20px;
    }

    .ant-carousel>>>.slick-prev {
        margin: -22px 0 0 -38px;
    }

    .ant-carousel>>>.slick-next {
        margin: -22px -38px 0 0;
    }

    .ant-statistic>>>.ant-statistic-title {
        font-size: 12px;
    }

    .ant-statistic>>>.ant-statistic-content {
        font-size: 14px;
    }
}
</style>
